import { Extension } from '@tiptap/core';
import { dropCursor } from '@tiptap/pm/dropcursor';
var Dropcursor = Extension.create({
  name: 'dropCursor',
  addOptions: function addOptions() {
    return {
      color: 'currentColor',
      width: 1,
      class: undefined
    };
  },
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    return [dropCursor(this.options)];
  }
});
export { Dropcursor, Dropcursor as default };